import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {SESSION_STORAGE, WebStorageService} from 'ngx-webstorage-service';
import {CookieService} from 'ngx-cookie-service';
import {OidcSecurityService} from "angular-auth-oidc-client";


@Injectable({
  providedIn: 'root'
})
export class ApiService {

  developingMode = false;
  api = 'https://app.elimedi.com';

  constructor(private http: HttpClient,
              @Inject(SESSION_STORAGE) private session: WebStorageService,
              private cookieService: CookieService,
              public oidcSecurityService: OidcSecurityService) {
    if (this.developingMode) {
      this.api = '';
    }
  }

  currentDirection = 'rtl';

  onSetLanguage(language, lan_id) {
    this.cookieService.set('dir', language);
    this.cookieService.set('lang', lan_id);
  }
  GetImage(Md5) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
      lang: this.cookieService.get('lang')
    });

    return this.http.get(this.api + '/api/Media/GetImage/'+ Md5, {headers});
  }

  GetLanguages() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
    });
    return this.http.get(this.api + '/api/admin/GetLanguages', {headers});
  }

  RegisterConfirm() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
    });
    return this.http.get(this.api + '/api/Account/RegisterConfirm', {headers});
  }

  getListMedicalExpertise(){
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
      lang: this.cookieService.get('lang')
    });
    return this.http.get(this.api + '/api/ElimediDoctor/getListMedicalExpertise/', {headers});
  }

  addMedicalExpertise(body){
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
      lang: this.cookieService.get('lang')
    });
    return this.http.post(this.api + '/api/ElimediAdmin/addMedicalExpertise/', body,{headers});
  }

  GetRequestMediaInfo(id){
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
      lang: this.cookieService.get('lang')
    });
    return this.http.get(this.api + '/api/ElimediAdmin/GetRequestMediaInfo/'+id,{headers});
  }


  getListRequestsManager(){
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
      lang: this.cookieService.get('lang')
    });
    return this.http.get(this.api + '/api/ElimediAdmin/getListRequestsManager/',{headers});
  }
  getListRequestDoctor(){
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
      lang: this.cookieService.get('lang')
    });
    return this.http.get(this.api + '/api/ElimediAdmin/getListRequestDoctor/',{headers});
  }

  ConfirmManagerAndDoctor(id){
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
      lang: this.cookieService.get('lang')
    });
    return this.http.get(this.api + '/api/ElimediAdmin/ConfirmManagerAndDoctor/'+id,{headers});
  }
  getListManager(){
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
      lang: this.cookieService.get('lang')
    });
    return this.http.get(this.api + '/api/ElimediAdmin/getListManager/',{headers});
  }
  ShowProfile(id){
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
      lang : this.cookieService.get('lang'),
      'Content-Type': 'application/json;charset=UTF-8'
    });
    return this.http.get(this.api + '/api/ElimediAdmin/ShowProfile/'+id,{headers});
  }


























}
